module.exports = __webpack_public_path__ + "static/media/Portrait-10234.644de9c4.jpg";